import ApiService from "./services/api/ApiService.js";
import {ApiProvider} from "./context/ApiContext.jsx";
import {AuthProvider} from "./context/AuthContext.jsx";
import AppRouter from "./Router/AppRouter.jsx";
import Config from "./config/config.js";
import PageCache from "./services/cache/PageCache.js";
import {PageCacheProvider} from "./context/PageCacheContext.jsx";
import {useEffect, useMemo} from "react";
import {AlertProvider} from "./context/AlertContext.jsx";
import React from "react";

function App({deps}) {
    if(Config.env !== 'production') {
        console.log(`This page is using a ${Config.env} build of React. See how this interacts with <React.StrictMode> here. https://legacy.reactjs.org/docs/strict-mode.html`)
        console.log(JSON.stringify(Config));
    }

    const api = useMemo(() => deps?.api ?? new ApiService(Config.apiBaseUrl, Config.apiCacheDriver), [deps]);
    const pageCache = useMemo(() => deps?.pageCache ?? new PageCache(Config.host, Config.pageCacheDriver), [deps]);

    useEffect(() => {
        const f = async () => {await api.applyCacheVersion(Config.apiCacheVersion);}
        f();
    }, [api]);

    useEffect(() => {
        const f = async () => {await pageCache.applyCacheVersion(Config.pageCacheVersion);}
        f();
    }, [pageCache]);

    return (
            <AlertProvider>
                <ApiProvider apiInstance={api}>
                    <AuthProvider>
                        <PageCacheProvider cacheInstance={pageCache}>
                            <AppRouter />
                        </PageCacheProvider>
                    </AuthProvider>
                </ApiProvider>
            </AlertProvider>
    );
}
export default App;
